import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BsModalService} from 'ngx-bootstrap/modal';

@Injectable({
  providedIn: 'root'
})
export class ChangePasswordService {

  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) { }

  loadUserConfig() {
    return this.http.get<any>('api/changePassword/loadUserConfig');
  }

  savePassword(param) {
    return this.http.post<void>('api/changePassword/savePassword', param);
  }
}
